module.exports = __webpack_public_path__ + "static/media/img4.f47a8f40.jpg";